<div class="card" *ngIf="this.Model?.itemCount < 1">
  <div class="card-body">
    <div class="well">
      <div class="top20 margin-bottom-20 text-center">
        <h4>Your Cart is Empty.</h4>
        <p>
          But it doesn't have to be this way.There are lots of amazing photography and video gadgets that you can shop
          for..
        </p>
        <br />
        <a class="btn mdkit-button btn-raised btn-info bmd-ripple" href="/"> <i class="fa fa-home"></i> Return Home </a>
      </div>
    </div>
  </div>
</div>

<app-bundle-list *ngFor="let b of this.Model.BundleSets; index as i"
                 [bundleSet]="b"
                 [Model]="this.Model"
                 [Spacer]="i !== 0"></app-bundle-list>
<app-bundle-builder #bundleBuilder (bundleUpdated)="onBundleUpdated($event)"></app-bundle-builder>

<app-cart-customization
                        [recordId]="giftCardRecordId"
                        [itemAttributes]="giftCardAttributes"
                        [webcode]="giftCardWebcode"
                        [show]="displayGiftCardEditModal"
                        (showChange)="onGiftCardUpdated($event)"
                        class="vistekweb"></app-cart-customization>

<div class="card" *ngIf="Model.UnBundledItems?.length" [class.mt-5]="this.Model.BundleSets?.length !== 0">
  <div *ngIf="IsWaiting">
    <div class="backdrop">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <h4 class="text-muted d-flex mb-4 mt-6">
      <strong>
        <span class="text-primary">{{ Model.UnBundledItems.length }} Items </span> in your Cart
      </strong>
      <span class="blue-text"></span>
    </h4>

      <div class="col">
        <div class="col" *ngFor="let p of this.Model.UnBundledItems" [attr.data-testid]="'cart-item-' + p.Webcode">
          <!--Product row-->
          <div class="row d-flex p-2">
            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
              <h6 class="font-weight-bold mb-3">Product</h6>
              <img src="{{ getImageURL(p.ImageDataburst) }}" class="img-fluid cart-item-thumbnail" />
            </div>

            <div class="col-lg-4 col-md-4 col-sm-9 col-xs-12">
              <h6 class="font-weight-bold mb-3">Description</h6>
              <div>
                <small class="cart-item-description">{{ p.Description }}</small><br />
                  <div>
                      <small class="text-muted">
                          <span
                              [style.text-decoration]="p.Attributes.RegularPrice != p.UnitPrice && 'line-through'"
                              class="item-unit-price"
                          >
                            {{ p.Attributes.RegularPrice | currency }}
                          </span>
                          <strong 
                              class="red-text"
                              *ngIf="p.Attributes.RegularPrice > 0 && p.Attributes.RegularPrice != p.UnitPrice"
                          >
                              SAVE 
                              <span class="database-rebate-amount">
                                {{ p.Quantity * (p.Attributes.RegularPrice - p.UnitPrice) | currency }}
                              </span>
                        </strong>
                      </small>
                  </div>
                  <div attr.data-testid="line-discount-{{p.Webcode}}">
                      <small class="text-muted">
                          <div *ngFor="let discount of p.DiscountItems"
                               class="p-1 rounded-sm success-color text-white z-depth-1 mb-2 line-discount"
                          >
                              <span class="line-discount-name">{{ discount.Attributes.RuleName }}</span>
                              <strong class="line-discount-amount">{{ -discount.UnitPrice * discount.Quantity | currency }}</strong>
                          </div>
                      </small>
                  </div>

                  <div>
                      <small>
                          Webcode: <span class="item-webcode">{{ p.Webcode }}</span>
                      </small>
                  </div>
                  <div
                      *ngIf="p.IsDigitalItem"
                      class="badge green"
                      triggers="hover"
                      placement="right"
                      container="body"
                      mdbPopoverHeader="Digital Item"
                      mdbPopover="This item is digital. It will be delivered via email."
                  >
                      Digital Item <i class="fas fa-question-circle"></i>
                  </div>

                  <small
                      *ngIf="showDropshippingBadge && dropshippedItems.includes(p.Webcode)"
                      style="color: white;"
                      class="badge orange hand"
                      triggers="hover"
                      placement="top"
                      container="body"
                      [mdbPopover]="dropshippedItemTemplate"
                      mdbPopoverHeader="Additional Drop Ship Quote Required"
                  >
                      Additional Drop Ship Quote Required <i class="fas fa-info-circle"></i>
                  </small>
              </div>
            </div>
            <div class="col" *ngIf="p.ParentRecordID"></div>
            <div class="col"
                 *ngIf="!p.ParentRecordID"
                 style="padding-right: 5px !important; padding-left: 5px !important; height: fit-content;">

              <div class="font-weight-bold mb-3">
                <i class="fa fa-check text-success" *ngIf="p.StockingStatus === 'In Stock'"></i>

                <span *ngIf="p.FinalSale"
                      class="badge red hand"
                      triggers="hover"
                      placement="top"
                      container="body"
                      mdbPopoverHeader="Special Order:"
                      mdbPopover="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment.">
                  Special order <i class="fas fa-info-circle"></i>
                </span>

                <span *ngIf="!p.FinalSale" style="width: 220px !important"> {{ p.StockingStatus }}</span>
              </div>
              <small *ngIf="p.StockingStatus === 'In Stock'">Ready to Ship</small>
            </div>

            <div class="col" style="padding-right: 5px !important; padding-left: 5px !important">
              <ng-container *ngIf="!isQtyLockedSku(p)">
                <h6 class="font-weight-bold mb-3">Qty</h6>
                <input type="number"
                  [(ngModel)]="p.Quantity"
                  (change)="changeItemQuantity(p)"
                  aria-label="Search"
                  class="form-control item-quantity-input"
                   data-test='product-quantity'
                  style="width: 65px"
                  min="1" 
                />
              </ng-container>
            </div>

            <div class="col" style="padding-right: 5px !important; padding-left: 5px !important">
              <h6 class="font-weight-bold mb-3">Item Total</h6>
              <strong class="item-total-price">{{ p.LineTotal | currency }}</strong>
            </div>
          </div>
          <!-- Product Row  buttons -->
          <div class="row d-flex border-bottom" style="padding-bottom: 10px">
            <div class="col-6 d-flex justify-content-start">
              <div class="small hand btnItem" *ngIf="isCustomizableSku(p.Webcode)" (click)="onGiftCartEdit(p)">
                <mdb-icon far icon="edit"></mdb-icon> Edit
              </div>
              <div class="small hand btnItem" (click)="removeItem(p)" data-testid='remove-cart-item'>
                <mdb-icon far icon="trash-alt"></mdb-icon> Remove
              </div>
            </div>
            <div class="col-6 d-flex justify-content-end" *ngIf="!p.ParentRecordID">
              <div class="small hand btnItem" (click)="saveItemForLater(p)" data-testid='save-cart-item'>
                <mdb-icon far icon="clock"></mdb-icon> Save Item
              </div>
            </div>
          </div>
          
          <app-service-plans-row
            [parentItemWebCode]="p.Webcode"
            [servicePlans]="p.ServicePlans"
            [isOnCartPage]="true"
          ></app-service-plans-row>

        </div>

        <!-- Product totals -->
        <div class="row d-flex p-2 text-end">
          <div class="col-lg-7"></div>
          <div class="col-lg-3 col-6">
            Instant Savings: <br />
            <strong>Item Total: </strong>
          </div>
          <div class="col-lg-2 col-6">
            <strong class="text-success"> {{ Model.CartSummary.unbundledSavings | currency }} </strong><br />
            <strong>
              {{ Model.CartSummary.unbundledSubtotal| currency }}
            </strong>
          </div>

      </div>

  </div>
</div>

</div>

<app-promotion-item *ngFor="let p of this.Model.OrderLevelPromotions" [item]="p"></app-promotion-item>

<ng-template #dropshippedItemTemplate>
    <p>This item is dropshipped and is not calculated in your instant shipping quote.</p>
    <p>You will be contacted after your order is placed with a shipping quote for the dropshipped item(s).</p>
</ng-template>